/**
 * jvRootModal Directive
 *
 * Used for appending the modal to the body so it shows properly
 * when used in nested markup.
 *
 * Also cleans up after itself.
 */

angular.module('jv.common.root-modal.directive', []).
directive('jvRootModal', [
    '$timeout', '$rootScope',
    function($timeout, $rootScope) {
        return {
            requires: 'jvModal',
            link: function(scope, elm, attrs) {
                var deregister;
                angular.element(document.body).append(elm);
                deregister = scope.$on('$routeChangeStart', function() {
                    var config = scope.$eval(attrs.jvRootModal);
                    if (config && config.showOnRouteChange) {
                        return;
                    }
                    if (scope.$eval(attrs.ngShow)) {
                        scope.$eval(attrs.jvModalHide);
                        $rootScope.$broadcast('resetJvModal');
                    }
                });

                scope.$on('$destroy', function() {
                    deregister();
                    $timeout(function() {
                        elm.remove();
                    });
                });
            }
        };
    }
]);